export default __webpack_public_path__ + "static/media/tiger-lunar-hero.5014af63.svg";